module.exports = __webpack_public_path__ + "f29d51094af65998592290de22a03ba4.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/graviton_-_agudabold_1-webfont.woff2
// module id = 1311
// module chunks = 28